export default {
  write: {
    en: 'Write a review',
  },
  edit: {
    en: 'Edit your review',
  },
  modalText: {
    en: ' to write a review',
  },
}
